/**
 * SponsorBadge — "Sponsored by" label for activity pages, cards, and map previews.
 *
 * Transparent, calm, secondary to coordination content.
 * Label is always explicit: "Sponsored by [Business Name]"
 * Never a call-to-action. Never promotional clutter.
 */

import React, { useState, useEffect } from 'react';
import { Star } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function SponsorBadge({ activityId, placementType = 'activity_page' }) {
  const [placard, setPlacard] = useState(null);

  useEffect(() => {
    if (!activityId) return;

    const fetchPlacard = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        const res = await fetch(`${API}/api/revenue/placards/mine`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return;
        const data = await res.json();
        const match = data.placards?.find(
          p => p.placement_type === placementType
        );
        if (match) setPlacard(match);
      } catch {
        // Silent — sponsor badge is non-critical
      }
    };

    fetchPlacard();
  }, [activityId, placementType]);

  if (!placard) return null;

  return (
    <div
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs"
      style={{
        backgroundColor: 'var(--fy-surface-muted)',
        color: 'var(--fy-text-disabled)',
        border: '1px solid var(--fy-border-subtle)',
      }}
      data-testid="sponsor-badge"
    >
      <Star className="w-3 h-3" style={{ color: '#EC4899' }} />
      <span className="italic">Supported by {placard.business_name}</span>
    </div>
  );
}
